import React from 'react'
import { CalligraphicExercisesReportDetailView } from '../../views'
import {
  LocalStorageService,
  UserService,
  RequestSignatureReplicationService
} from "../../../services";
import { SimpleLoading } from '../../pures';
class CalligraphicExercisesReportDetailAction extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      user: null,
      isLoading: false,

      message: '',
      showLoadingRequesting: false,
      showCompletedRequesting: false,
      showErrorRequesting: false
    }
  }

  token = {}
  url = process.env.REACT_APP_MIFIRMA_API
  localStorageService = new LocalStorageService()
  UserService = new UserService(this.url);
  requestSignatureReplicationService = new RequestSignatureReplicationService(this.url);


  async componentDidMount() {
    this.setState({ loading: true })
    this.token = this.localStorageService.getLocalStorageItem('token').idToken
    let user = this.localStorageService.getLocalStorageItem('user')

    let usersCollabotartorInvites = await this.UserService.getUsersCollaboratorInvite(this.token)
    if (!usersCollabotartorInvites) {
      usersCollabotartorInvites.usersCollaborator = []
      usersCollabotartorInvites.usersInvite = []
    }
    this.setState({
      collaboratorListAllow: usersCollabotartorInvites.usersCollaborator,
      inviteListAllow: usersCollabotartorInvites.usersInvite,
      loading: false,
      user
    });

  }

  scrollWindow = () => {
    window.scrollTo(0, 0)
  }

  /**
  * @author Alan Aguilar
  * @description Function to show or hide the LoadingRequesting Dialog
  * @updatedDate 10-12-2021
  * @param {Boolean} value
  * @memberof CalligraphicExercisesReportDetailAction
  */
  toggleLoadingRequesting = (value) => {
    this.setState({ showLoadingRequesting: value })
  }

  /**
  * @author Alan Aguilar
  * @description Function to show or hide the CompletedRequesting Dialog
  * @updatedDate 10-12-2021
  * @param {Boolean} value
  * @param {Boolean} redirect
  * @memberof CalligraphicExercisesReportDetailAction
  */
  toggleCompletedRequesting = (value, redirect) => {
    this.setState({
      showCompletedRequesting: value
    }, () => {
      setTimeout(() => {
        this.setState({ showCompletedRequesting: false })
        if (redirect === true) this.props.history.push('/')
      }, 2000)
    })
  }

  /**
  * @author Alan Aguilar
  * @description Function to show or hide the ErrorRequesting Dialog
  * @updatedDate 10-12-2021
  * @param {Boolean} value
  * @memberof CalligraphicExercisesReportDetailAction
  */
  toggleErrorRequesting = (value) => {
    this.setState({
      showErrorRequesting: value
    }, () => {
      setTimeout(() => {
        this.setState({ showErrorRequesting: false })
      }, 2000)
    })
  }

  onSubmit = async (data) => {
    let backendStatusCode = 0
    this.scrollWindow()

    try {
      await this.toggleLoadingRequesting(true)
      let result = await this.requestSignatureReplicationService.postRequestSignatureReplication(this.token, { userEmail: data.email })
      if (!result.statusCode === 200) {
        backendStatusCode = Number(result.statusCode)
        throw new Error()
      }

      await this.toggleLoadingRequesting(false)
      await this.toggleCompletedRequesting(true, true)
      return true
    } catch (error) {
      switch (backendStatusCode) {
        case -420:
          this.setState({ message: `Alguna de las imágenes proporcionadas no está en formato .jpg o .png.` })
          break
        case -2:
          this.setState({ message: `El correo de usuario proporcionado no pudo ser encontrado en los registros de govo.legal.` })
          break
        default:
          this.setState({ message: `Ocurrio un error al realizar la petición, intente nuevamente.` })
      }
      await this.toggleLoadingRequesting(false)
      await this.toggleErrorRequesting(true)
      return false
    }
  }

  render() {
    let { isLoading } = this.state
    return (
      <React.Fragment>
        <div className='standard-wrapper' style={!isLoading ? {} : { display: 'none' }}>
          <CalligraphicExercisesReportDetailView
            {...this.state}
            onSubmit={this.onSubmit}
            toggleLoadingRequesting={this.toggleLoadingRequesting}
            toggleCompletedRequesting={this.toggleCompletedRequesting}
            toggleErrorRequesting={this.toggleErrorRequesting}
          />
        </div>
        <div className='loading' style={isLoading ? {} : { display: 'none' }}>
          <SimpleLoading />
        </div>
      </React.Fragment>
    )
  }
}


export { CalligraphicExercisesReportDetailAction as default }
